import { buttonClasses } from "@mui/material/Button";

function getContainedVars(color) {
    return {
        "--Button-containedBg": `var(--mui-palette-${color}-main)`, // Use main, not dark for base
        "--Button-containedBgHover": `var(--mui-palette-${color}-dark)`,
        "--Button-containedStroke": `inset 0px 1px 0px 0px rgba(255, 255, 255, 0.1)`, // Top highlight
    };
}

function getOutlinedVars(color, dark) {
    return {
        "--Button-outlinedBorder": `var(--mui-palette-${color}-main)`,
        "--Button-outlinedHoverBg": `var(--mui-palette-${color}-hovered)`,
        "--Button-outlinedActiveBg": `var(--mui-palette-${color}-activated)`,
    };
}

function getTextVars(color) {
    return {
        "--Button-textHoverBg": `var(--mui-palette-${color}-hovered)`,
        "--Button-textActiveBg": `var(--mui-palette-${color}-activated)`,
    };
}

export const MuiButton = {
    defaultProps: { disableRipple: false }, // Ripple fits Material Design better
    styleOverrides: {
        root: {
            borderRadius: "8px", // Consistent with Inputs
            fontWeight: 600, // Make text pop
            minHeight: "var(--Button-minHeight)",
            minWidth: "unset",
            textTransform: "none", // No ALL CAPS
            "&:focus-visible": { outline: "2px solid var(--mui-palette-primary-main)" },
        },
        text: {
            "&:hover": { backgroundColor: "var(--Button-textHoverBg)" },
            "&:active": { backgroundColor: "var(--Button-textActiveBg)" },
        },
        // Map vars...
        textPrimary: getTextVars("primary"),
        textSecondary: getTextVars("secondary"),
        textSuccess: getTextVars("success"),
        textInfo: getTextVars("info"),
        textWarning: getTextVars("warning"),
        textError: getTextVars("error"),

        outlined: {
            boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
            borderColor: "var(--Button-outlinedBorder)",
            borderWidth: "1px",
            "&:hover": {
                borderColor: "var(--Button-outlinedBorder)",
                backgroundColor: "var(--Button-outlinedHoverBg)",
            },
            "&:active": { backgroundColor: "var(--Button-outlinedActiveBg)" },
        },
        // Map Outlined vars...
        outlinedPrimary: ({ theme }) => getOutlinedVars("primary", theme.palette.mode === "dark"),
        outlinedSecondary: ({ theme }) => getOutlinedVars("secondary", theme.palette.mode === "dark"),
        outlinedSuccess: ({ theme }) => getOutlinedVars("success", theme.palette.mode === "dark"),
        outlinedInfo: ({ theme }) => getOutlinedVars("info", theme.palette.mode === "dark"),
        outlinedWarning: ({ theme }) => getOutlinedVars("warning", theme.palette.mode === "dark"),
        outlinedError: ({ theme }) => getOutlinedVars("error", theme.palette.mode === "dark"),

        contained: {
            backgroundColor: "var(--Button-containedBg)",
            boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05), var(--Button-containedStroke)",
            "&:hover": {
                backgroundColor: "var(--Button-containedBgHover)",
                boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)",
            },
            "&:active": { boxShadow: "inset 0 2px 4px 0 rgba(0,0,0,0.06)" },
            [`&.${buttonClasses.disabled}`]: { boxShadow: "none" },
        },
        // Map Contained vars...
        containedPrimary: getContainedVars("primary"),
        containedSecondary: getContainedVars("secondary"),
        containedSuccess: getContainedVars("success"),
        containedInfo: getContainedVars("info"),
        containedWarning: getContainedVars("warning"),
        containedError: getContainedVars("error"),

        sizeSmall: { "--Button-minHeight": "32px", fontSize: "0.8125rem", padding: "4px 12px" },
        sizeMedium: { "--Button-minHeight": "40px", fontSize: "0.875rem", padding: "6px 16px" },
        sizeLarge: { "--Button-minHeight": "48px", fontSize: "0.9375rem", padding: "8px 24px" },
    },
};
